import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { WithOnDestroy } from '@schenck/rotec-components';
import { Observable } from 'rxjs';
import { filter, map, takeUntil } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LoggedInGuard extends WithOnDestroy {
  private readonly authService = inject(MsalService);
  private readonly msalBroadcastService = inject(MsalBroadcastService);
  private readonly router = inject(Router);

  constructor() {
    super();
  }

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    this.authService.handleRedirectObservable().pipe(takeUntil(this.onDestroy$)).subscribe();
    return this.msalBroadcastService.inProgress$.pipe(
      filter((status: InteractionStatus) => status === InteractionStatus.None),
      takeUntil(this.onDestroy$),
      map(() => {
        const isAuth = this.authService.instance.getAllAccounts().length !== 0;

        // If the user is authenticated, redirect them to the root page
        // Which then redirects them to the default page setup in main.ts
        if (isAuth) {
          this.router.navigate(['/']);
        }

        return !isAuth;
      })
    );
  }
}
